export const ourFastCasinoGameDevelopmentServicesTextContent = {
  headingText: "Our Fast Casino Game Development Services",
  btnText: "Hire Now",
  imageSrc: "/assets/stock-img/fast_casino_game_development_services_img.webp",
  content: [
    {
      listContent_1: [
        { listText: "Moon Casino Game Development" },
        { listText: "Plinko Casino Game Development" },
        { listText: "Aviator Casino Game Development" },
        { listText: "Fast-Baccarat Casino Game Development" },
        { listText: "Dice Casino Game Development" },
        { listText: "Crash Casino Game Development" },
        { listText: "UNO Casino Game Development" },
        { listText: "Mines Casino Game Development" },
        { listText: "Bitcoin Fast Casino Game Development" },
      ],
    },
    {
      listContent_2: [
        { listText: "Hilo Casino Game Development" },
        { listText: "Fast-Blackjack Casino Game Development" },
        { listText: "Limbo Casino Game Development" },
        { listText: "Coin Flip Casino Game Development" },
        { listText: "Fast-Roulette Casino Game Development" },
        { listText: "White Label Fast Casino Game Development" },
        { listText: "Crypto Fast Casino Game Development" },
        { listText: "Turnkey Fast Casino Game Development" },
      ],
    },
  ],
};
